import AgentActivity from 'models/agent_activity';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';

export default class CloseCommentPanel {
  constructor(context) {
    this.context = context;
  }

  run() {
    const commentPanel = this.context.stores.commentPanel.get();
    commentPanel.close();
    commentPanel.clearItemId();
    this.context.stores.commentPanel.set(commentPanel);

    this.context.executeAction(SetAndLogActivity, {
      type: AgentActivity.Type.TASK_COMMENT_PANEL_CLOSE,
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/task/close_comment_panel.js